import { emailPattern } from '@/utils/utils';
import * as yup from 'yup';

export const tourBookingSchema = {
  duration: yup.number().required('required'),
  pickUp: yup
    .string()
    .trim()
    .required('required')
    .test(
      'duplicatedDropOff',
      'duplicatedPlace',
      (value: any, ctx: any) => value && value !== ctx.parent.dropOff,
    ),
  adults: yup
    .string()
    .trim()
    .required('required')
    .test(
      'isPositiveAdults',
      'onlyPositive',
      (value: any) => Number(value) > 0,
    ),
  // children: yup
  //   .string()
  //   .trim()
  //   .test(
  //     'isPositiveChildren',
  //     'onlyPositive',
  //     (value: any) => !value || Number(value) >= 0,
  //   ),
  note: yup.string().trim(),
};

export const tourBookingContactInfoSchema = {
  fullName: yup.string().trim().required('required'),
  // .matches(/^[a-zA-Z\s]+$/, 'fullNameInvalid'),
  phone: yup.string().trim().matches(/^\d*$/, 'phoneInvalid'),
  email: yup
    .string()
    .trim()
    .email('emailInvalid')
    .when('phone', {
      is: '',
      then: schema => schema.required('required'),
      otherwise: schema => schema,
    }),
  zalo: yup.string().trim().matches(/^\d*$/, 'zaloInvalid').nullable(),
  whatsapp: yup.string().trim().matches(/^\d*$/, 'whatsappInvalid').nullable(),
  kakaotalk: yup.string().trim(),
};

export const tourBookingCustomerSchema = {
  //duration: yup.number().required('required'),
  tourPriceOptionId: yup.string().required('required'),
  pickUp: yup
    .string()
    .trim()
    .required('required')
    .test(
      'duplicatedDropOff',
      'duplicatedPlace',
      (value: any, ctx: any) => value && value !== ctx.parent.dropOff,
    ),
  adults: yup
    .string()
    .trim()
    .required('required')
    .test(
      'isPositiveAdults',
      'onlyPositive',
      (value: any) => Number(value) > 0,
    ),
  note: yup.string().trim(),
  fullName: yup.string().trim().required('required'),
  phone: yup
    .string()
    .trim()
    .matches(/^\d*$/, 'phoneInvalid')
    .nullable()
    .test('atLeastOneContact', 'required', function (value) {
      const { email, zalo, whatsapp, kakaotalk, contactNumber } = this.parent;
      if (!email && !zalo && !whatsapp && !kakaotalk && !contactNumber) {
        return true;
      }
      return Boolean(
        value || email || zalo || whatsapp || kakaotalk || contactNumber,
      );
    }),
  email: yup
    .string()
    .trim()
    .matches(emailPattern, 'emailInvalid')
    .nullable()
    .test('atLeastOneContact', 'required', function (value) {
      const { phone, zalo, whatsapp, kakaotalk, contactNumber, viber } =
        this.parent;
      if (!phone && !zalo && !whatsapp && !kakaotalk && !viber) {
        return true;
      }
      return Boolean(
        value ||
          phone ||
          zalo ||
          whatsapp ||
          kakaotalk ||
          contactNumber ||
          viber,
      );
    }),
  zalo: yup
    .string()
    .trim()
    .matches(/^\d*$/, 'zaloInvalid')
    .nullable()
    .test('atLeastOneContact', 'required', function (value) {
      const { phone, email, whatsapp, kakaotalk, viber, contactNumber } =
        this.parent;
      if (!phone && !email && !whatsapp && !kakaotalk && !viber) {
        return true;
      }
      return Boolean(
        value ||
          phone ||
          email ||
          whatsapp ||
          kakaotalk ||
          viber ||
          contactNumber,
      );
    }),
  whatsapp: yup
    .string()
    .trim()
    .matches(/^\d*$/, 'whatsappInvalid')
    .nullable()
    .test('atLeastOneContact', 'required', function (value) {
      const { phone, email, zalo, kakaotalk, viber, contactNumber } =
        this.parent;
      if (!phone && !email && !zalo && !kakaotalk && !viber) {
        return true;
      }

      return Boolean(
        value || phone || email || zalo || kakaotalk || viber || contactNumber,
      );
    }),
  kakaotalk: yup
    .string()
    .trim()
    .nullable()
    .test('atLeastOneContact', 'required', function (value) {
      const { phone, email, zalo, whatsapp, viber, contactNumber } =
        this.parent;

      if (!phone && !email && !zalo && !whatsapp && !viber) {
        return true;
      }

      return Boolean(
        value || phone || email || zalo || whatsapp || viber || contactNumber,
      );
    }),
  contactNumber: yup
    .string()
    .trim()
    .nullable()
    .test('atLeastOneContact', 'required', function (value) {
      const { phone, zalo, whatsapp, kakaotalk, viber, email } = this.parent;
      if (!phone && !email && !zalo && !whatsapp && !viber) {
        return true;
      }
      return Boolean(value || phone || zalo || whatsapp || kakaotalk || viber);
    }),
  viber: yup
    .string()
    .trim()
    .nullable()
    .test('atLeastOneContact', 'required', function (value) {
      const { phone, email, zalo, whatsapp, kakaotalk, contactNumber } =
        this.parent;
      if (!phone && !email && !zalo && !whatsapp && !kakaotalk) {
        return true;
      }
      return Boolean(
        value ||
          phone ||
          email ||
          zalo ||
          whatsapp ||
          kakaotalk ||
          contactNumber,
      );
    }),
  timeIdSelected: yup.number().typeError('required').required('required'),
};
